export default function usePaymentOptions(): any {
  function repaymentTermEnum(repaymentTermId: number): number {
    switch (repaymentTermId) {
      case 1:
        return 5;
      case 2:
        return 7;
      case 3:
        return 10;
      case 4:
        return 15;
      case 5:
        return 20;
      case 6:
        return 25;
      default:
        return 0;
    }
  }
  function getRateTypeName(rateTypeId: number): string {
    switch (rateTypeId) {
      case 1:
        return "Fixed";
      case 2:
        return "Variable";
      default:
        return "";
    }
  }
  function getRateOptionHeader(rateTypeId: number): string {
    switch (rateTypeId) {
      case 1:
        return "Fixed Interest Rate";
      case 2:
        return "Variable Interest Rate";
      default:
        return "";
    }
  }

  function getRepaymentTermHeader(repaymentTerm: number): string {
    switch (repaymentTerm) {
      case 20:
        return "20-25";
      default:
        return `${repaymentTerm}`;
    }
  }

  function getOrdinal(n: number) {
    let ord = "th";

    if (n % 10 == 1 && n % 100 != 11) {
      ord = "st";
    } else if (n % 10 == 2 && n % 100 != 12) {
      ord = "nd";
    } else if (n % 10 == 3 && n % 100 != 13) {
      ord = "rd";
    }

    return n + ord;
  }

  function formatRatePercentages(n: number, decimalPlaces: number) {
    return `${n.toLocaleString(undefined, { minimumFractionDigits: decimalPlaces })}%`;
  }

  function formatStartOfQuarter(date: any) {
    if (date) {
      const dateObj = new Date(date);
      const day = dateObj.getDate();
      const formattedDay = getOrdinal(day);
      const month = dateObj.toLocaleString("en-us", { month: "long" });
      const year = dateObj.toLocaleString("en-us", { year: "numeric" });

      return `${month} ${formattedDay}, ${year}`;
    }
  }
  return {
    getRateTypeName,
    repaymentTermEnum,
    getRateOptionHeader,
    getRepaymentTermHeader,
    getOrdinal,
    formatRatePercentages,
    formatStartOfQuarter,
  };
}
